import * as types from "./types";

const initialState = {
  vapi: {
    isReady: false,
    isCallActive: false,
    isSpeaking: false,
    isMuted: false,
    isAssistantMuted: false,
    pendingMuteAfterSpeech: false,
    isWaitingForAssistantToStartSpeaking: false, // Track initial connection period
    hasAssistantJoinedCall: false, // Track if assistant has joined the call
    transcript: "",
    elapsedTime: 0,
    callStartTime: null,
    error: null,
    assistantId: null,
    showPermissionCheck: false,
    pendingAssistantId: null,
    callData: null,
    languageConfig: null, // Store language configuration
    // Call quota tracking
    quotaSeconds: null, // Total allowed call duration in seconds
    remainingSeconds: null, // Remaining call duration in seconds
    isUpgraded: false, // Whether user has premium subscription
  },
};

export default function aiReducer(state = initialState, action) {
  switch (action.type) {
    case types.VAPI_SERVICE_READY:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isReady: action.payload.isReady,
        },
      };

    case types.VAPI_SERVICE_ERROR:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          error: action.payload.error,
        },
      };

    case types.VAPI_CALL_START:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isCallActive: true,
          isWaitingForAssistantToStartSpeaking: true, // Start in waiting mode
          hasAssistantJoinedCall: false, // Reset assistant status
          callStartTime: Date.now(),
          assistantId: action.payload.assistantId,
          languageConfig: action.payload.languageConfig,
          error: null,
          showPermissionCheck: false,
          pendingAssistantId: null,
        },
      };

    case types.VAPI_CALL_END:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isCallActive: false,
          isSpeaking: false,
          isAssistantMuted: false,
          pendingMuteAfterSpeech: false,
          isWaitingForAssistantToStartSpeaking: false,
          hasAssistantJoinedCall: false,
          transcript: "",
          elapsedTime: 0,
          callStartTime: null,
          callData: null,
          // Reset quota tracking
          quotaSeconds: null,
          remainingSeconds: null,
        },
      };

    case types.VAPI_CALL_ERROR:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          error: action.payload.error,
        },
      };

    case types.VAPI_CALL_STATUS_UPDATE:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isCallActive: action.payload.isCallActive,
        },
      };

    case types.VAPI_TRANSCRIPT_UPDATE:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          transcript: action.payload.transcript,
        },
      };

    case types.VAPI_SPEAKING_STATUS_UPDATE:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isSpeaking: action.payload.isSpeaking,
        },
      };

    case types.VAPI_SET_ELAPSED_TIME:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          elapsedTime: action.payload.elapsedTime,
          // Update remaining seconds based on elapsed time and quota
          remainingSeconds:
            state.vapi.quotaSeconds !== null
              ? Math.max(
                  0,
                  state.vapi.quotaSeconds - action.payload.elapsedTime
                )
              : null,
        },
      };

    case types.VAPI_SHOW_PERMISSION_CHECK:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          showPermissionCheck: true,
          pendingAssistantId: action.payload.assistantId,
        },
      };

    case types.VAPI_HIDE_PERMISSION_CHECK:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          showPermissionCheck: false,
        },
      };

    case types.VAPI_CALL_CONNECTED:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          callData: action.payload.callData,
        },
      };

    case types.VAPI_TOGGLE_MUTE:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isMuted: !state.vapi.isMuted,
        },
      };

    case types.VAPI_MUTE_ASSISTANT:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isAssistantMuted: true,
          pendingMuteAfterSpeech: false,
        },
      };

    case types.VAPI_SAY_AND_MUTE_AFTER:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          pendingMuteAfterSpeech: true,
        },
      };

    case types.VAPI_UNMUTE_ASSISTANT:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isAssistantMuted: false,
        },
      };

    case types.VAPI_TOGGLE_ASSISTANT_MUTE:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isAssistantMuted: !state.vapi.isAssistantMuted,
        },
      };

    case types.VAPI_ASSISTANT_JOINED_CALL:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          hasAssistantJoinedCall: action.payload.hasJoined,
        },
      };

    case types.VAPI_SET_WAITING_FOR_ASSISTANT:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          isWaitingForAssistantToStartSpeaking: action.payload.isWaiting,
        },
      };

    case types.VAPI_SET_CALL_QUOTA:
      return {
        ...state,
        vapi: {
          ...state.vapi,
          quotaSeconds: action.payload.quotaSeconds,
          remainingSeconds: action.payload.quotaSeconds,
          isUpgraded: action.payload.isUpgraded,
        },
      };

    default:
      return state;
  }
}
